<mat-sidenav-container  (backdropClick)="closeSideSheet()"  class="page">
    <mat-sidenav class="sidenav"
                #sidenav
                position="end"
                [opened]="isSideSheetOpen$ | async"
                [disableClose]="true"
   >
        <ng-container *ngIf="(sideSheetContent$ | async) != null">
            <ng-container *cdkPortalOutlet="sideSheetContent$ | async" ></ng-container>
        </ng-container>

    </mat-sidenav>

    <ion-router-outlet *ngIf="isMobile$ | async"></ion-router-outlet>
    <router-outlet *ngIf="!(isMobile$ | async)"></router-outlet>

</mat-sidenav-container>
